var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinOutlined = function SvgPinOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 6.448c-2.009 0-3.637 1.67-3.637 3.728S9.99 13.904 12 13.904s3.637-1.67 3.637-3.728S14.01 6.448 12 6.448m-2.662 3.728c0-1.506 1.192-2.728 2.662-2.728s2.662 1.222 2.662 2.728S13.47 12.904 12 12.904s-2.662-1.221-2.662-2.728",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.35 15.622.009-.008 4.639 5.384 4.986-5.779C18.126 13.89 19 12.173 19 10.179 19 6.215 15.866 3 12 3s-7 3.215-7 7.18c0 1.991.803 3.583 2.007 5.03zM5.977 10.18C5.976 6.766 8.673 4 12 4s6.024 2.766 6.024 6.18c0 1.68-.736 3.173-1.772 4.378l-4.254 4.93-4.321-5.016c-1.065-1.304-1.701-2.65-1.701-4.293",
    clipRule: "evenodd"
  })));
};
export default SvgPinOutlined;